export function getFlagTextColor(flagText) {
  switch (flagText.toLowerCase()) {
    case "new launch":
      return "#C31C00";
    case "best seller":
      return "#016990";
    case "hettich recommends":
      return "#026543";
    case "limited time offer":
      return "#af8201";
    case "made in bharat":
      return "#013b51";
    case "made in germany":
      return "#daa200";
    case "premium range":
      return "#383738";
    case "trending":
      return "#75b798";
    default:
      return "#2a6d8a";
  }
}
